export default "__VITE_ASSET__d5585ac6__"